import { addSortOrderItem } from './search';

export const sorterCriteria = (key: string, condition: boolean) => {
  const filter: any = [];

  if (key) filter.push(addSortOrderItem(`${key}`, condition ? 'ASC' : 'DESC'));

  return filter;
};
